import axios from 'axios';

import { IJobsDownloadTemplate } from '../../JobsDownloadTemplateService';

export const saveCandidateDownloadTemplaes = (payload: IJobsDownloadTemplate) =>
  axios.post('/candidatesearch/api/download-settings-template/save', payload);

export const getCandidateDownloadTemplates = () =>
  axios.get('/candidatesearch/api/download-settings-template/get-templates');

export const getCandidateDownloadTemplateById = (id: string) =>
  axios.get(`/candidatesearch/api/download-settings-template/get-template/${id}`);

export const deleteCandidateDataDownloadSettingsTemplate = (templateId: string) =>
  axios.delete(`/candidatesearch/api/download-settings-template/delete-template/${templateId}`);

export const hideCandidateDataDownloadSettingsTemplate = (templateId: string, isHidden: boolean) =>
  axios.post(
    `/candidatesearch/api/download-settings-template/hide-template/${templateId}/${isHidden}`
  );

export const favoriteCandidateDataDownloadSettingsTemplate = (
  templateId: string,
  isFavorite: boolean
) =>
  axios.post(
    `/candidatesearch/api/download-settings-template/favorite-template/${templateId}/${isFavorite}`
  );
